import { faTelegram } from "@fortawesome/free-brands-svg-icons";
import { faCoins, faInfo } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default [
  {
    header: "Links",
  },
  {
    id: "chungus",
    title: "About",
    newTab: true,
    icon: <FontAwesomeIcon icon={faInfo} />,
    externalLink: true,
    navLink: "https://ChungusCoinBSC.io",
  },
  {
    id: "telegram",
    title: "Telegram",
    newTab: true,
    icon: <FontAwesomeIcon icon={faTelegram} />,
    externalLink: true,
    navLink: "https://t.me/chunguscoin",
  },
  {
    id: "buy-bcc",
    title: "Buy $BCC",
    newTab: true,
    icon: <FontAwesomeIcon icon={faCoins} />,
    externalLink: true,
    navLink: "https://exchange.pancakeswap.finance/#/swap?outputCurrency=0xa397233a0c08052df7569b089864afeb7dc7f8b0",
  },
];
